<template>
  <div>
    <!-- File input -->
    <div class="full_impoter">

      <div class="">
          <div class="">
            <div class="file-input-container">
              <label :for="'file-input-'+id" class="file-label">
                <span id="file-name"><span v-if="file">{{this.selectedFile.name}}</span><span v-else>Select a file</span></span>
              </label>
              <input type="file" :id="'file-input-'+id" ref="fileInput" class="file-input" @change="handleFileChange" :accept="acceptTypes">
            </div>
            <div v-if="fileError" class="error-message">
              {{ fileError }}
            </div>
          </div>

      </div>

    <button @click="uploadFile" v-if="file" class="uploadFile_btn">
      <span>UPLOAD FILE</span>
      <img :src="require('@/assets/updataroom.svg')" alt="">
    </button>
    </div>
    <!-- Progress Bar -->
    <div v-if="uploading" class="ai_loader_2">
      <div class="ai_loader_in2">
        <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
        <div class="ai_loader_text2">Upload in progress...</div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '../tools/api';
import { toast } from 'vue-sonner'
export default {
  name: "FileUpload",
  props: {
    filetype: {
      type: String,
      required: true,  // Ensure filetype is passed as a prop
    },
  },
  data() {
    return {
      id:  Math.floor(Math.random() * 50),
      apiUrl: process.env.VUE_APP_API_URL,
      file: null,
      selectedFile : null,
      uploading: false, // For showing progress bar
      progress: 0, // For progress value
      uploadResult: null, // For storing upload result
      fileError: null, // To store error messages
      acceptTypes: ".pdf", // Accept types for the file input
    };
  },
  methods: {
    // Handle file input change
    handleFileChange(event) {
      console.log(event);
       const selectedFile = event.target.files[0];

       // Validate file type
       const allowedTypes = ["application/pdf", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "image/png", "image/jpeg"];
       if (!allowedTypes.includes(selectedFile.type)) {
         this.fileError = "Invalid file type. Please upload a PDF, Excel, PNG, or JPG.";
         this.file = null;
         return;
       }

       // Validate file size (2GB = 2 * 1024 * 1024 * 1024 bytes)
       const maxSize = 1 * 1024 * 1024 * 1024;
       if (selectedFile.size > maxSize) {
         this.fileError = "File is too large. Please upload a file smaller than 1GB.";
         this.file = null;
         return;
       }
       console.log(selectedFile);
       // If the file is valid, store it
       this.selectedFile = selectedFile;
       this.file = selectedFile;
       this.fileError = null; // Clear previous error
     },

     resetFileInput() {
           this.$refs.fileInput.value = null; // Reset the input field
           this.file = null; // Clear the file data
           this.fileError = null; // Clear any error
         },
    // Upload file function
    async uploadFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("filetype", this.filetype);

      this.uploading = true; // Show the progress bar

      try {
      await api.post(process.env.VUE_APP_API_URL+"/restrict/add_file_to_dataroom", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          },
        });
        toast.success("File successfully added to your dataroom");
        this.$emit('fileAdded');
        this.resetFileInput();
      } catch (error) {
        console.log(error);
          toast.error("Error during file upload, please try again");
      } finally {

        this.uploading = false; // Hide progress bar when done
      }
    },
  },
};
</script>


<style scoped>
.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #CCC;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;
}

.progress-bar-fill {
  height: 100%;
  background-color: #3783C5;
  width: 0;
  transition: width 0.4s;
}

.uploadFile_btn{
  display:flex;
  align-items: center;
  padding:10px 20px;
  gap:20px;
  background: #3783C5;
  color:#FFF;
  text-transform: uppercase;
  border-radius:200px;
  font-size:14px;
}
.uploadFile_btn:disabled{
  opacity: .8;
}
.full_impoter{
  width:100%;
  display:flex;
gap:20px;
  align-items: center;
}
@media screen and (max-width:1000px){
  .uploadFile_btn{
    display:flex;
    align-items: center;
    padding:7px 12px;
    gap:10px;
    background: #3783C5;
    color:#FFF;
    text-transform: uppercase;
    border-radius:200px;
    font-size:14px;
  }
  .uploadFile_btn img{
    width:25px;
  }


}
@media screen and (max-width:690px){
  .uploadFile_btn{
    display:flex;
    align-items: center;
    padding:7px 12px;
    gap:10px;
    background: #3783C5;
    color:#FFF;
    text-transform: uppercase;
    border-radius:200px;
    font-size:14px;
  }
  .uploadFile_btn img{
    width:25px;
  }
  .full_impoter{
    width:100%;
    display:flex;
    flex-direction: column;
    gap:20px;
    align-items: flex-start;
  }

}


/* Hide the actual file input */
.file-input {
  display: none;
}

/* Style the label that will act as the "button" */
.file-label {

  padding: 10px 20px;
  border-radius: 50px;
  border: 1px dashed #3783C5;
  background-color: #FFF;
  color: #3783C5;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}

/* Add hover effect on label */
.file-label:hover {
  opacity: .8;
}

.error-message{
  background: #FED7DF;
  color: #C60932;
  padding: 5px 10px;
  font-size: 13px;
  border-radius:10px;
  margin-top:5px;
}
.ai_loader_2{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,.2);
  width: 100%;
  display: block;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.ai_loader_in2{
  background: #FFF;
  padding: 20px;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-content: center;
  align-items: center;

}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai_loader_in2 img{
  width:45px;
  animation: rotate 3s linear infinite;
}

.ai_loader_in2 .ai_loader_text2{
  font-size: 18px;
  font-weight: 600;
  color:#04246A;
}

</style>
